import { client as axios } from "./axiosClient";
import { Constants } from "@socialcoach/services";
import { catchServiceException } from "@socialcoach/services";
import * as DTO from "../interfaces/dtos";
import { ClientNotes } from "@/interfaces";

const VIDEO_PROJECT_SERVICE = `${Constants.API_URL}/video-catalyst`;

export class VideoProjectServices {
  @catchServiceException()
  static async get(id: string | number): Promise<DTO.VideoProjectDetail> {
    const { data } = await axios.get<DTO.VideoProjectDetail>(`${VIDEO_PROJECT_SERVICE}/${id}`, {
      withCredentials: true,
    });
    return data;
  }

  @catchServiceException()
  static async getPlayersWithVideoProjects(coachId: string | number): Promise<DTO.PlayerResumeResponse[]> {
    const { data } = await axios.get<DTO.PlayerResumeResponse[]>(`${VIDEO_PROJECT_SERVICE}/coach/${coachId}/players`, {
      withCredentials: true,
    });
    return data;
  }

  @catchServiceException()
  static async getLatestVideoProjectPreferences(playerId: number): Promise<DTO.VideoPreferences> {
    const { data } = await axios.get<DTO.VideoPreferences>(
      `${VIDEO_PROJECT_SERVICE}/player/preferences?playerId=${playerId}`,
      {
        withCredentials: true,
      }
    );
    return data;
  }

  @catchServiceException()
  static async getVideoCatalystStatus(playerId: number | string): Promise<DTO.VideoCatalystStatus> {
    const { data } = await axios.get<DTO.VideoCatalystStatus>(`${VIDEO_PROJECT_SERVICE}/player/${playerId}/status`, {
      withCredentials: true,
    });
    return data;
  }

  @catchServiceException()
  static async getPlayerSummaries(coachId: string | number): Promise<DTO.VideoProjectPlayerSummary[]> {
    const { data } = await axios.get<DTO.VideoProjectPlayerSummary[]>(
      `${VIDEO_PROJECT_SERVICE}/coach/${coachId}/players/summary`,
      {
        withCredentials: true,
      }
    );
    return data;
  }

  @catchServiceException()
  static async getCoachConfig(coachId: string | number): Promise<DTO.VideoProjectCoachConfig> {
    const { data } = await axios.get<DTO.VideoProjectCoachConfig>(`${VIDEO_PROJECT_SERVICE}/coach/${coachId}/config`, {
      withCredentials: true,
    });
    return data;
  }

  @catchServiceException()
  static async updatePlayerConfig(
    playerId: number,
    config: DTO.VideoProjectPlayerConfigRequest
  ): Promise<DTO.VideoCatalystStatus> {
    const { data } = await axios.post<DTO.VideoCatalystStatus>(
      `${VIDEO_PROJECT_SERVICE}/player/${playerId}/config`,
      config,
      { withCredentials: true }
    );
    return data;
  }

  @catchServiceException()
  static async updateCoachConfig(
    coachId: string,
    config: DTO.VideoProjectCoachConfig
  ): Promise<DTO.VideoProjectCoachConfig> {
    const { data } = await axios.post<DTO.VideoProjectCoachConfig>(
      `${VIDEO_PROJECT_SERVICE}/coach/${coachId}/config`,
      config,
      { withCredentials: true }
    );
    return data;
  }

  @catchServiceException()
  static async addClientNotes(playerId: number | string, notes: string): Promise<ClientNotes> {
    const { data } = await axios.post<ClientNotes>(
      `${VIDEO_PROJECT_SERVICE}/player/client-notes`,
      {
        notes,
        playerId,
      },
      {
        withCredentials: true,
      }
    );
    return data;
  }

  @catchServiceException()
  static async getPlayerNotes(playerId: number | string): Promise<ClientNotes | undefined> {
    const { data } = await axios.get<ClientNotes | undefined>(
      `${VIDEO_PROJECT_SERVICE}/player/client-notes?playerId=${playerId}`,
      {
        withCredentials: true,
      }
    );
    return data;
  }

  @catchServiceException()
  static async getCoachNotes(coachId: number | string): Promise<ClientNotes | undefined> {
    const { data } = await axios.get<ClientNotes | undefined>(
      `${VIDEO_PROJECT_SERVICE}/coach/client-notes?coachId=${coachId}`,
      {
        withCredentials: true,
      }
    );
    return data;
  }

  @catchServiceException()
  static async addCoachClientNotes(coachId: string | number, notes: string): Promise<ClientNotes> {
    const { data } = await axios.post<ClientNotes>(
      `${VIDEO_PROJECT_SERVICE}/player/client-notes`,
      {
        notes,
        coachId,
      },
      {
        withCredentials: true,
      }
    );
    return data;
  }
}
